"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { IServiceHours } from "@/interfaces/service-hours.interface";
import serviceHoursService from "@/services/service-hours.service";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type Return = RequestsBaseReturn<PaginatedResponse<IServiceHours> | null>;

type GetAllSwrParams = [string, number, number];

const useGetServiceHours = ({ pageNumber, pageSize }: RequestPagination): Return => {
  const fetcher = useSWR<PaginatedResponse<IServiceHours>, Error, GetAllSwrParams>(
    [SWR_KEYS.getServiceHours, pageNumber, pageSize],
    ([, _pageNumber, _pageSize]) =>
      serviceHoursService.getAll({
        pageNumber: _pageNumber,
        pageSize: _pageSize,
      }),
    { revalidateOnFocus: false }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetServiceHours;
